/**
 * 购物车相关 API 接口
 */

import type {
  CartItemAddReq,
  CartItemAddResp,
  CartItemBatchRemoveReq,
  CartItemListReq,
  CartItemListResp,
  CartItemRemoveReq,
  CartItemUpdateReq,
  CartListResp,
} from "@/types/cart";
import { request } from "@/utils/fetch";

// ============================================
// 购物车 API 接口
// ============================================

/**
 * 获取购物车列表
 * 返回当前用户的所有购物车（6个订单组）及其商品
 */
export const getCartList = () => {
  return request<CartListResp>({
    url: "/api/v1/supplier/cart/list",
    method: "POST",
    data: {},
  });
};

/**
 * 增加购物车商品数量
 * 按购物车索引+SKU一组，只做数量增加，不创建新商品
 * @param params 增加商品数量请求参数
 */
export const addCartItem = (params: CartItemAddReq) => {
  return request<CartItemAddResp>({
    url: "/api/v1/supplier/cart/item/add",
    method: "POST",
    data: params,
  });
};

/**
 * 更新购物车商品数量
 * @param params 更新数量请求参数
 */
export const updateCartItemQuantity = (params: CartItemUpdateReq) => {
  return request({
    url: "/api/v1/supplier/cart/item/update",
    method: "POST",
    data: params,
  });
};

/**
 * 移除购物车商品
 * @param params 移除商品请求参数
 */
export const removeCartItem = (params: CartItemRemoveReq) => {
  return request({
    url: "/api/v1/supplier/cart/item/remove",
    method: "POST",
    data: params,
  });
};

/**
 * 批量移除购物车商品
 * @param params 批量移除请求参数
 */
export const batchRemoveCartItems = (params: CartItemBatchRemoveReq) => {
  return request({
    url: "/api/v1/supplier/cart/item/batch-remove",
    method: "POST",
    data: params,
  });
};

/**
 * 获取指定购物车商品列表
 * @param params 购物车索引请求参数
 */
export const getCartItemList = (params: CartItemListReq) => {
  return request<CartItemListResp>({
    url: "/api/v1/supplier/cart/item/list",
    method: "POST",
    data: params,
  });
};
